import { render, staticRenderFns } from "./OrganisationSelection.vue?vue&type=template&id=4d1aa94a&scoped=true&"
import script from "./OrganisationSelection.vue?vue&type=script&lang=js&"
export * from "./OrganisationSelection.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationSelection.vue?vue&type=style&index=0&id=4d1aa94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1aa94a",
  null
  
)

export default component.exports